/*
 * @Author: Gaho
 * @Date: 2024-01-29 10:29:59
 * @LastEditors: Gaho
 * @LastEditTime: 2024-07-08 13:48:03
 */
export const ruleData = [
    {
        content1: 'coinflipRule1',
        constent2: '',
        img: null,
    }
]